import { Component, Input } from '@angular/core';
import { ModalService } from '../modal.service';
import { ScheduleStoreService } from 'src/app/pages/schedule/schedule-store.service';
import { ToastService } from '../../toast/toast.service';

@Component({
    selector: 'app-schedule-items-modal',
    templateUrl: './schedule-items-modal.component.html',
    styleUrls: ['./schedule-items-modal.component.scss'],
})
export class ScheduleItemsModalComponent {
    @Input() data: any;

    startDate: any;
    endDate: any;
    startTime: any;
    endTime: any;

    minStartDate: any = '';
    minEndDate: any = '';
    maxStartDate: any = '';

    myData: any;
    currentId: any;

    scheduleItemsArray: any = [];
    multiSchedule: any = [];

    constructor(
        private modal: ModalService,
        private scheduleStore: ScheduleStoreService,
        private toast: ToastService
    ) {}

    ngOnInit() {
        console.log(this.data);
        this.currentId = this.data.arg[0];
        console.log(this.currentId);

        // this.myData = this.scheduleStore.getMultiScheduleItemData();
        // console.log(this.myData);

        const index = this.data.arg[1].findIndex((item: any) => {
            if (item.id === this.currentId) {
                // let obj = { ...item.schedule };
                if (item.schedule !== undefined) {
                    this.scheduleItemsArray = item.schedule;
                } else {
                    let schedule = ['24x7'];
                    this.scheduleItemsArray = schedule;
                }
            }
        });
        console.log(this.scheduleItemsArray);
        this.multiSchedule = this.scheduleItemsArray.map((multi: any) => {
            return {
                'Start Date': multi.startdate,
                'End Date': multi.enddate,
                'Start Time': multi.starttime,
                'End Time': multi.endtime,
                Actions: [],
            };
        });
    }

    setDate(event: any, type: string) {
        console.log('date:', event.target.value);
        if (type == 'start') {
            this.startDate = event.target.value;
            this.minEndDate = this.startDate;
        } else if (type == 'end') {
            this.endDate = event.target.value;
            this.maxStartDate = this.endDate;
        }
    }

    setTime(event: any, type: string) {
        console.log('time:', event.target.value);
        if (type == 'start') {
            this.startTime = event.target.value;
        } else if (type == 'end') {
            this.endTime = event.target.value;
        }
    }

    clearTime(type: string) {
        console.log('TYPE', type);
        // this.timeInput.nativeElement.value = '';
        if (type == 'start') {
            this.startTime = '';
        } else if (type == 'end') {
            this.endTime = '';
        }
        // this.setScheduleFilter();
    }

    addSchedule() {
        if (this.startDate && this.endDate && this.startTime && this.endTime) {
            let startdate = this.startDate;
            let enddate = this.endDate;
            let starttime = this.startTime;
            let endtime = this.endTime;

            if (
                new Date(startdate).getTime() === new Date(enddate).getTime() &&
                new Date(`${startdate}T${starttime}`) > new Date(`${enddate}T${endtime}`)
            ) {
                this.toast.showToast('Start time should be before end time', 'error');
                return;
            }

            let schedule = {
                ...(startdate && { startdate }),
                ...(enddate && { enddate }),
                ...(starttime && { starttime }),
                ...(endtime && { endtime }),
            };

            let isOverLapping = this.scheduleItemsArray.some((schedule: any) => {
                let existingStartValue = new Date(`${schedule.startdate}T${schedule.starttime}`);
                let existingEndValue = new Date(`${schedule.enddate}T${schedule.endtime}`);

                let newStartValue = new Date(`${startdate}T${starttime}`);
                let newEndValue = new Date(`${enddate}T${endtime}`);

                return newStartValue < existingEndValue && newEndValue > existingStartValue;
            });

            if (!isOverLapping) {
                console.log(this.scheduleItemsArray, schedule);
                this.scheduleItemsArray.push(schedule);
                console.log(this.scheduleItemsArray);
            } else {
                this.toast.showToast('Conflicting Schedules', 'error');
            }
            // let obj = { id: '', schedule: [] };

            // obj.id = this.currentId;

            // obj.schedule = this.scheduleItemsArray;

            // console.log(obj);
        } else {
            this.toast.showToast('Please select all the fields startdate, enddate, starttime, endtime', 'error');
        }

        this.multiSchedule = this.scheduleItemsArray.map((multi: any) => {
            return {
                'Start Date': multi.startdate,
                'End Date': multi.enddate,
                'Start Time': multi.starttime,
                'End Time': multi.endtime,
                Actions: [],
            };
        });
    }

    deleteBtnAction(index: any) {
        console.log(index);
        this.scheduleItemsArray.splice(index, 1);
        console.log(this.scheduleItemsArray);
    }

    submitItemsSchedule() {
        console.log(this.data);
        const fullDaySchedule = this.scheduleItemsArray.filter((val: any) => val === '24x7');

        if (fullDaySchedule.length === 1 && this.scheduleItemsArray.length > 1) {
            this.toast.showToast('Remove 24x7 from the list', 'error');
        } else {
            let obj = this.data.arg[1].find((item: any) => item.id === this.currentId);
            console.log(obj);

            this.data.callback(this.data.arg[0], obj, this.scheduleItemsArray, this.data.arg[2]);
            this.modal.closeModal();
        }
    }
}
